import { Select } from '@apia/theme';
import { observer } from 'mobx-react-lite';
import { TFilterRenderer } from './types';
import { arrayOrArray } from '@apia/util';
import FilterLabel from '../FilterLabel';

export const SelectFilterRenderer: TFilterRenderer = observer(({ state }) => {
  return (
    <>
      <FilterLabel state={state} isDate />
      <Select
        className="filter__query"
        data-query-filter-id={state.id}
        data-query-filter-part="value"
        sx={{
          '&.filter__query.filter__query:not([disabled])': {
            borderLeft: state.required ? '4px solid' : undefined,
            borderLeftColor: state.required ? 'palette.error.main' : undefined,
          },
        }}
        disabled={state.readonly}
        value={state.value}
        onChange={(ev) => {
          state.value = ev.target.value;
        }}
      >
        {arrayOrArray(state.options).map((c) => (
          <option key={c.value} value={c.value}>
            {c.label}
          </option>
        ))}
      </Select>
    </>
  );
});
